import { Gallery } from '@/domain/types/collections';
import { Column } from '@/presentation/components/table';
import { MdImage } from 'react-icons/md';

export const columnsGalleries: Column<Gallery>[] = [
  { header: 'Título (ES)', accessor: 'title' },
  { header: 'Título (EN)', accessor: 'titleEN' },
  {
    header: 'Imágenes',
    accessor: 'images',
    render: (value) => {
      const images = value as Gallery['images'];
      return (
        <div className="flex items-center gap-2">
          <MdImage className="text-blue-500" size={20} />
          <span>{images?.length || 0} imagen(es)</span>
        </div>
      );
    },
  },
  {
    header: 'Fecha de creación',
    accessor: 'createdAt',
    render: (value) => {
      if (value && typeof value === 'object' && 'seconds' in value) {
        const date = new Date((value as { seconds: number }).seconds * 1000);
        return <span>{date.toLocaleDateString('es-ES')}</span>;
      }
      return <span>-</span>;
    },
  },
];
